import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/cart';

const CartIcon = () => {
    const { getTotalItems } = useCart();
    const totalItems = getTotalItems();

    return (
        <Link 
            to="/Cart" 
            className="cart-icon"
            style={{ 
                position: 'relative', 
                textDecoration: 'none', 
                color: 'inherit',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '8px',
                borderRadius: '4px',
                transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
            <div style={{ 
                fontSize: '24px', 
                position: 'relative' 
            }}>
                🛒
                {totalItems > 0 && (
                    <span className="cart-badge" style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: '20px'
                    }}>
                        {totalItems > 99 ? '99+' : totalItems}
                    </span>
                )}
            </div>
        </Link>
    );
};

export default CartIcon;